import { useState, useEffect, useRef, useCallback } from 'react';
import { Trans } from '@lingui/macro';
import { shouldbeBranded } from '@utils/Utils';
import { useIsMobile } from '@utils/hooks/useIsMobile';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faXmark } from "@fortawesome/pro-regular-svg-icons"

import './style.scss';

const SlideUp = ({ header, headerPrefix, children, className, onClose, defaultOpen, onOpen, buttonHeaderOveride, open: controlledOpen }) => {
    const [open, setOpen] = useState(controlledOpen !== undefined ? controlledOpen : defaultOpen || false);
    const [isClosing, setClosing] = useState(false)
    const mobile = useIsMobile();
    const bodyRef = useRef(document.body);

    const setOpenState = () => {
        bodyRef.current.style.overflow = 'hidden';
        document.querySelector('#nav-bar-bottom').style.zIndex = 998;
        document.querySelector('.nav-bar').classList.add('hidden');

        if (!shouldbeBranded()) {
            document.querySelector('.slide-up-parent').style.transform = 'translateY(0px)'
        }
        
        if (document.querySelector('.preview-banner')) {
            document.querySelector('.preview-banner').style.transform = 'translateY(-100%)';
            document.querySelector('.body').style.marginTop = "0";
        }

        document.querySelector('.floating-elements').style.zIndex = 997;
    }

    const setClosedState  = () => {
         bodyRef.current.style.overflow = "initial";
        document.querySelector('#nav-bar-bottom').style.zIndex = 997;
        document.querySelector('.nav-bar').classList.remove('hidden');
       
        if (!shouldbeBranded()) {
            document.querySelector('.slide-up-parent').style.transform = 'translateY(75px)'
        }

        if (document.querySelector('.preview-banner')) {
            document.querySelector('.preview-banner').style.transform = 'translateY(0)';
            document.querySelector('.body').style.marginTop = '36px';
        }

        document.querySelector('.floating-elements').style.zIndex = 997;
    }

    const openContainer = () => {
        setOpen(true);
        if (onOpen) {
            onOpen(true)
        }
       
        setOpenState()
    }

    const closeContainer = useCallback(() => {
        setClosing(true)
        setTimeout(() => {
            setClosing(false)
            setOpen(false)
            if (onClose) {
                onClose()
                
            }
        }, 0)

        setClosedState()
    }, [onClose]);

    useEffect(() => {
        if (open) {
            setOpenState()
        }
    }, [open, mobile])
    
    // SIDE EFFECT: close modal when controlled state is toggled and the slideUp is open at that point in time
    useEffect(() => {
        if (controlledOpen && !open) {
            closeContainer()
        }
    }, [controlledOpen, open, closeContainer])

    
    const getClassName = () => {
        if (open && !isClosing) {
            return 'is-open'
        } else if (open && isClosing) {
            return 'is-closed'
        }
    }

    const handleOpenChange = controlledOpen !== undefined ? controlledOpen : open;

    return (
        <>
            {!controlledOpen && !defaultOpen && (
                children.length
                    ? <div onClick={openContainer}>{children[0]}</div>
                    : <div className={`slide-up-button ${buttonHeaderOveride ? 'btn': ''}`} onClick={openContainer} style={{    
                             }}>
                            <h5>{headerPrefix ? <Trans id={headerPrefix} values={headerPrefix} /> : ''}
                            {headerPrefix && !buttonHeaderOveride && ' '}
                            {!buttonHeaderOveride ? <Trans id={header} values={header} />: ''}</h5>
                            {!buttonHeaderOveride ? <FontAwesomeIcon icon={faChevronRight} /> : ''}
                        </div>
            )}
            <div className={`slide-up-parent${handleOpenChange  ? ' open' : ''}${controlledOpen ? ' lite' : ''}`}>
                <div className={`slide-up-container ${getClassName()}${className ? ` ${className}` : ''}`}>
                    <div className="slide-up-header">
                            <FontAwesomeIcon icon={faXmark} size='xl' onClick={closeContainer} />
                            <h6><Trans id={header} values={header} /></h6>
                        </div>
                        <div className="break-words slide-up-body">
                            {children.length ? children[1] : children}
                    </div>
                </div>
            </div>
        </>
    )
}

export default SlideUp;